<template>
  <div class="representantes">
    <div class="row m-0">
      <div class="col-lg-3 col-md-3 col-sm-12 col-12 p-0 bg-gray-1">
        <div class="menu-area-restrita">
          <Topic :text="'Informações'" :icon="'fas fa-user-circle'" />
          <!-- <BasicItem
            :text="'Meus Dados'"
            :icon="'fas fa-list-alt'"
            :routeName="'parceiro-meus-dados'"
          /> -->
          <BasicItem
            :text="'Sair'"
            :icon="'fas fa-power-off'"
            :routeName="'sair'"
          />

          <!-- Fim dos Meus Dados -->
          <Topic class="mt-4" :text="'Ações'" :icon="'fas fa-clipboard-list'" />
          <BasicItem
            v-if="!this.dadosUsuario.externo"
            class="col-8"
            text="Ranking"
            icon="fas fa-trophy"
            routeName="parceiro-ranking"
          />
          <BasicItem
            v-if="this.dadosUsuario.externo"
            class="col-8"
            text="Ranking Externo"
            icon="fas fa-trophy"
            routeName="parceiro-externo-ranking"
          />
          <!-- <BasicItem
            class="col-8"
            text="Dashboard"
            icon="fas fa-chart-pie"
            routeName="dashboard"
          /> -->
          <BasicItem
            class="col-8"
            :text="'Lojistas Não Ativos'"
            :icon="'fas fa-user-times'"
            :routeName="'nao-ativos'"
          />
          <BasicItem
            class="col-8"
            :text="'Portfolio de Vendas'"
            :icon="'fas fa-portrait'"
            :routeName="'parceiro-portfolio'"
          />
          <BasicItem
            class="col-8"
            :text="'Cadastrar Lojista'"
            :icon="'fas fa-store'"
            :routeName="'parceiro-cadastrar-lojista'"
          />
          <BasicItem
            class="col-8"
            :text="'Indicar profissionais'"
            :icon="'fas fa-hand-point-right'"
            :routeName="'parceiro-indicar-profissional'"
          />
          <BasicItem
            class="col-8"
            :text="'Relátorio'"
            :icon="'fas fa-chart-bar'"
            :routeName="'parceiro-relatorio'"
          />
          <BasicItem
            class="col-8"
            :text="'Treinamento'"
            :icon="'fas fa-video'"
            :routeName="'link-youtube-treinamento'"
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-12 p-0">
        <div class="conteudo-area-restrita">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';
import ItemWithAnchor from '../../components/Menu/ItemWithAnchor.vue';

export default {
  name: 'AffiliateIndex',
  computed: {
    ...mapState(['dadosUsuario']),
  },
  components: {
    Topic,
    BasicItem,
    ItemWithAnchor,
  },
  methods: {
    redirect(link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style scoped>
@import '../../custom/css/admin-navigation.css';

.slide-nav li.item {
  text-transform: initial;
  color: var(--black);
}

.slide-nav li.item a {
  text-decoration: none;
  color: var(--black);
}
</style>
